var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12 p-24" },
    [
      _c(
        "div",
        {
          staticClass:
            "heading separator d-flex align-items-center xs-flex-start pr-8 xs-flex-column justify-space-between",
        },
        [
          _c("span", { staticClass: "word-break text-emergo-dark-blue" }, [
            _vm._v(
              " " +
                _vm._s(_vm.globalSearchInfo.total_search_result_count || 0) +
                " Result(s) for ‘" +
                _vm._s(_vm.searchTerm) +
                "’ "
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "emergo-white-button xs-flex-100",
              on: { click: _vm.navigateToDashboard },
            },
            [_vm._v(" Exit Search ")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "col-lg-12 p-0",
          attrs: { id: "searchResultAccordian" },
        },
        [
          _c(
            "div",
            { staticClass: "col-xs-12 p-0 p-relative filter-wrapper" },
            [
              _c("shared-left-filter", {
                attrs: {
                  chevronList: _vm.chevronList,
                  expectedFilter: _vm.resultingFilter,
                  countriesList: _vm.countryListFilter,
                  servicesList: _vm.servicesList,
                  isCountryString: true,
                  types: _vm.types,
                  hideServicesForGlobalSearch: _vm.isSingleService,
                },
                on: { setFilter: _vm.filteredOptions },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 p-0 list-wrapper accordion acc-pl" },
            _vm._l(_vm.filteredServices, function (record, index) {
              return _c(
                "div",
                { key: index, staticClass: "panel search-panel wrapper-panel" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "panel_title font-18 fw-400 text-secondary",
                      class: {
                        collapsed:
                          record.service_name !== _vm.selectedServiceName,
                      },
                      attrs: {
                        role: "button",
                        "data-toggle": "collapse",
                        "data-target": "#collapse" + index,
                        "aria-expanded": "true",
                        "aria-controls": "collapse" + index,
                        "data-parent": "#searchResultAccordian",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            `${record.result_count} Result(s) for '${_vm.searchTerm}' found in ${record.service_name}`
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse mt-14 result-list",
                      class: {
                        in: record.service_name === _vm.selectedServiceName,
                      },
                      attrs: {
                        id: "collapse" + index,
                        "data-parent": "#searchResultAccordian",
                        role: "tabpanel",
                        "aria-labelledby": "searchResults",
                      },
                    },
                    _vm._l(record.service_results, function (ele, index) {
                      return _c(
                        "div",
                        { key: ele.id, staticClass: "panel-body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.navigateToRespectivePage(
                                    record.service_name,
                                    ele
                                  )
                                },
                              },
                            },
                            [
                              _c("services", {
                                attrs: {
                                  serviceName: record.service_name,
                                  recordInfo: ele,
                                },
                              }),
                            ],
                            1
                          ),
                          index === 4
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "see-more text-emergo-dark-blue font-18 fw-400 cursor-pointer col-xs-12 p-0 d-flex justify-content-end",
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigateToServiceSearch(
                                        record.service_name
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" View All ")]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("div", { staticClass: "separator results" }),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("unsubscribed-country-popup", {
        attrs: {
          id: "modal_unsubscribed_market",
          isGlobalSearch: true,
          selectedServiceId: _vm.selectedServiceId,
        },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }